import CardSystem from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GameObject from '../../../GameObject/GameObject';
import Animator from '../../../Prototype/Animator';
import { UIEvent } from '../../UI/BaseUISystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';
import { CardBombExplosion } from 'System/Animation/Clip';

export default function BombCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData,
): void {
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);
    const sourceCard = system.getCardByID(taskData.cards[0]);
    sourceCard.getComponent(Renderable).visible = true;

    const targetCards: BaseCard[] = [];
    for (let i = 1; i < taskData.cards.length; i++) {
        const card: BaseCard = system.getCardByID(taskData.cards[i]);
        card.getComponent(Renderable).visible = false;
        targetCards.push(card);
    }

    const explosionAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(explosionAnimator);

    system.taskQueue.queueNext(
        new AnimationClipTask(
            new CardBombExplosion(explosionAnimator, { system, sourceCard, targetCards }, true),
        ),
    );
}
